import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Animation from '../../assets/img/404/animation-dudes-principle.gif';

function NotFound() {
	return (
		<div className="error-page">
			<Container>
				<Row>
					<Col
						xs={12}
						md={7}
						lg={{ offset: 1, span: 5 }}
						className="error-page__content"
					>
						<h2 className="uikit-label-small-caps">500 Error</h2>
						<h3 className="uikit-heading-lg error-page__heading">
							Server Error
						</h3>
						<p className="uikit-text-regular error-page__description">
							Sorry, we are down for a scheduled maintenance and will be up
							shortly. Thank you for your patience. Please check back soon!
						</p>
					</Col>
					<Col
						xs={12}
						md={5}
						lg={{ offset: 1, span: 5 }}
						xl={4}
						className="error-page__sidebar"
					>
						<div className="error-page__sidebar-inner">
							<img
								className="error-page__animation"
								src={Animation}
								alt="dudes"
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default NotFound;
